import { REDUX_STORE } from '../App';

export const getTimezoneLabel = timezone => {
  const supportedTimezones = REDUX_STORE.getState().common.timezones;

  return supportedTimezones.find(tmz => tmz.value === timezone)?.label;
};
